export function buildEntityOptionsRequestPath(entity: string): string {
  const normalizedEntity = entity.trim();
  const normalizedPath =
    normalizedEntity.startsWith('/') || normalizedEntity.startsWith('http')
      ? normalizedEntity
      : `/${normalizedEntity}`;

  if (
    normalizedEntity.includes('/') ||
    normalizedEntity.includes('?') ||
    normalizedEntity.startsWith('http')
  ) {
    return normalizedPath;
  }

  return `${normalizedPath}?all=true&status=ACTIVE`;
}
